import React from 'react';
import ProfileCard from './ProfileCard';
import { NO_PROFILE_PRIMARY, NO_PROFILE_SECONDARY } from '../constants/Constants';

const AllProfiles = ({ 
	profiles, 
	primaryText = NO_PROFILE_PRIMARY, 
	secondaryText = NO_PROFILE_SECONDARY
}) => {
	return (
		<div className="flex flex-col gap-4 w-full">
			{profiles.length > 0 ? (
				profiles.map((profile) => (
					<ProfileCard
						key={profile.id}
						profile={profile}
						isNameClickable={true}
						imageSize={200}
					/>
				))
			) : (
				<div className="flex flex-col items-center justify-center text-gray-500 py-10 px-4 text-center">
					<p className="text-lg font-medium">{primaryText}</p>
					<p className="text-sm">{secondaryText}</p>
				</div>
			)}
		</div>
	);
};

export default AllProfiles;
